
<div class="kpi-card {{kpiColor}} {{kpiWidth}}" [ngClass]="{left: isLeft}">
    <div style="position:relative;">
        <div class="kpi-card-right {{kpiColor}}">
            <img [src]="'assets/img/'+kpiImage+'.png'">
        </div>
    </div>

    <div class="kpi-card-left {{kpiColor}} {{kpiWidth}}">
        {{kpiTitle}}
    </div>

    <div *ngIf="(!kpiValue && kpiValue != 0) && !comingSoon; else elseBlock" style="width: 100%; height: 90px; background: transparent url('assets/img/loading.gif') no-repeat center center">&nbsp;</div>
    <ng-template #elseBlock>
        <div class="{{ comingSoon ? 'main-kpi-card comingSoon' : 'main-kpi-card'}}  {{kpiColor}}">
            {{kpiValue}}
        </div>
    </ng-template>
</div>
